<template>
  <div class="market-sidebar__payments">
    <h2 class="market-sidebar__title">
      {{ t('payment_methods') }}
    </h2>
    <h3 class="market-sidebar__title-small">
      {{ t('deposit') }}
    </h3>
    <div
      v-if="payments.length"
      class="payments-wrapper"
    >
      <div
        v-for="dep in payments"
        :key="dep.name"
        v-tooltip="dep.name"
      >
        <img
          :alt="dep"
          :src="`/img/market-pays/${dep.logo}`"
        >
      </div>
    </div>
    <h3 class="market-sidebar__title-small">
      {{ t('withdraw') }}
    </h3>
    <div
      v-if="payouts.length"
      class="payments-wrapper"
    >
      <div
        v-for="payout in payouts"
        :key="payout.name"
        v-tooltip="payout.name"
        class="payment"
      >
        <img
          :alt="payout"
          :src="`/img/market-pays/${payout.logo}`"
        >
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { MarketFullInfoPaymentMethod } from '~/graphql/generated/schema-types';

defineProps<{
  payments: MarketFullInfoPaymentMethod[]
  payouts: MarketFullInfoPaymentMethod[]
}>();

const { t } = useI18n();
</script>

<style lang="scss" scoped>
.market-sidebar__payments {
  display: flex;
  flex-direction: column;
  gap: 16px;

  .market-sidebar__title-small {
    margin-bottom: 0 !important;
    margin-top: 4px;
  }

  .payments-wrapper {
    display: grid;
    gap: 12px;
    grid-template-columns: repeat(auto-fit, minmax(0, 61px));
  }

  @media screen and (max-width: 850px) {
    padding-top: 16px;
  }
}
</style>
